<template>
	<div
		class="overlay-order-box"
		:class="{
			'overlay-order-box--inline': isInline,
		}"
		v-htmlclass="customHtmlClasses"
	>
		<div
			class="overlay-order-box__wrapper"
			@click.self="closeOverlay"
		>
			<div class="overlay-order-box__panel">
				<button
					class="overlay-order-box__close"
					@click.prevent="closeOverlay"
				>
					<SVGClose/>
				</button>
				<WidgetOrderbox
					ref="orderbox"
					:location-code="locationCode"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import WidgetOrderbox from '@/pages/WidgetOrderbox';
import GenericMixin from '@/mixins/GenericVueMixin';
import OverlayMixin from '@/mixins/OverlayVueMixin';
import {eventhub, EVENT_CART_CREATED} from '@/store/eventhub';

export default {
	mixins: [
		GenericMixin,
		OverlayMixin,
	],
	components: {
		WidgetOrderbox,
	},
	props: {
		overlayType: {
			type: String,
			default() {
				return 'overlay-orderbox';
			},
		},
		initialVisible: {
			type: Boolean,
			default: false
		},
		htmlClasses: {
			type: Array,
			default: () => ['hide--header', 'show--modal'],
		},
		isInline: {
			type: Boolean,
			default() {
				return false;
			},
		},
	},
	data() {
		return {
			visible: this.initialVisible,
			overlaysAllowed: [
				// 'group-order',
			],
			locationCode: null,
		}
	},
	methods: {
		onCartCreated() {
			this.closeOverlay();
		},
		beforeOverlayOpen() {
		  this.$store.dispatch('initializeOrderbox')
			this.overlaysAllowed = [
				'group-order',
			]
		},
		beforeOverlayClose() {
			this.overlaysAllowed = []
		},
		afterOverlayOpen(data) {
			this.locationCode = data.locationCode;
		},
		afterOverlayClose(data) {
			this.locationCode = null;
			this.$refs.orderbox.onCancel();
		},
	},
	mounted() {
		eventhub.$on(EVENT_CART_CREATED, this.onCartCreated)
	},
	destroyed() {
		eventhub.$off(EVENT_CART_CREATED, this.onCartCreated)
		this.html.classList.remove(this.overlayShowClass);
	}
}
</script>

<style>

</style>
